<div mat-dialog-title class="matDialogTitle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <mat-progress-bar mode="indeterminate" class="detaile" [hidden]="!loading"></mat-progress-bar>
    <span>
        <span>ریز پرداخت ها</span>
    </span>
    <span (click)="close()">
        <mat-icon class="close">close</mat-icon>
    </span>
</div>


<div mat-dialog-content class="matDialogContent">
    <div class="row" style="padding-bottom: 1rem;">

        <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12 padding0">
            <table class="table table-bordered">
                <tr>
                    <td>
                        <span>نام طرف حساب</span>
                    </td>
                    <td>{{ user_title }}</td>
                </tr>
                <tr>
                    <td>
                        <span> شماره همراه </span>
                    </td>
                    <td>{{ user_cellphone || '-' }}</td>
                </tr>
                <tr>
                    <td>
                        <span> شناسه پذیرش </span>
                    </td>
                    <td>{{ id2 }}</td>
                </tr>
                <tr>
                    <td>
                        <span> دستگاه / برند / مدل </span>
                    </td>
                    <td>{{ device }} / {{ brand }} / <span class="font-en">{{ model
                            }}</span></td>
                </tr>
            </table>
        </div>

        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 remain">
            <div class="remain_text1" (click)="get_balance()">
                <span>مانده حساب کل</span>
            </div>
            <div class="remain_text2">{{ remain | number }}</div>
            <div style="padding-top:0.5rem">{{ currency_title }}</div>
        </div>

        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 padding0" style="margin-top: 1rem;">
            <table class="table table-bordered">
                <tr>
                    <td>
                        <span>تخفیف از خدمات</span>
                    </td>
                    <td style="padding:0px !important">{{ discount_services || 0 | number }} {{ currency_title }}
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>تخفیف از کالا</span>
                    </td>
                    <td style="padding:0px !important">{{ discount_material || 0 | number }} {{ currency_title }}
                    </td>
                </tr>
                <tr style="background-color: #F1EFEA">
                    <td>
                        <span>مبلغ فاکتور</span>
                    </td>
                    <td>{{ sum || 0 | number }} {{ currency_title }}
                    </td>
                </tr>
            </table>
        </div>
    </div>

    <div class="row">
        <div style="text-align: center;margin-top: 1rem;">
            <button class="button_default button_default2" (click)="new_recieve_finance()">
                <span> دریافت از طرف حساب </span>
            </button>
            <button class="button_default button_default2" (click)="show_balance_detaile()">
                <span> مشاهده ریز تراکنش </span>
            </button>
            <button class="button_default button_default2" (click)="open_exit()">
                <span> مشاهده فاکتور </span>
            </button>
        </div>
    </div>
</div>

<div mat-dialog-actions class="matDialogActions" *ngIf="!status_empty_shelf">
    <button type="submit" class="btn_pe" (click)="update()">
        <span>انتقال به وضعیت تحویل داده شده</span>
    </button>
    <div style="padding-right:1rem;padding-top:0.2rem">
        <mat-radio-group aria-label="Select an option" name="device_status" [(ngModel)]="device_status">
            <div class="device_status_text">
                <span>وضعیت دستگاه :</span>
            </div>
            <mat-radio-button class="status_title_items reception-status" *ngFor="let x of list_device_status"
                [value]="x.repairman_device_status_id" [checked]="device_status == x.repairman_device_status_id">
                <span class="status_span_label">{{ x.repairman_device_status_title }}</span>
            </mat-radio-button>
        </mat-radio-group>
    </div>
</div>